import { Typography } from "@mui/material";
import { Link } from "react-router-dom";
import { colorAccent } from "src/design/tokens";

interface CardLinkProps {
  to: string;
  label: string;
}

/** The "see all →" shortcut sitting in a dashboard card's header. */
export const CardLink = ({ to, label }: CardLinkProps) => (
  <Typography
    component={Link}
    to={to}
    sx={{
      fontSize: "13px",
      fontWeight: 600,
      color: colorAccent,
      textDecoration: "none",
      whiteSpace: "nowrap",
      "&:hover": { textDecoration: "underline" },
    }}
  >
    {`${label} →`}
  </Typography>
);
